





















import Vue from "vue";
import * as routes from "@/router/routes";

// Vue components
import StandardPage from "@/components/PageTemplates/StandardPage.vue";
import PMMainTable from "./PMMainTable.vue";
import InstallationsPredictedStatusSummary from "./InstallationsPredictedStatusSummary.vue";

// Model
import { dataTableItemsPerPage } from "@/utility/Constants";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { FetchInstallationsPredictedStatusCommand, GetDevicesPredictedStatusReqData } from "@/model/communication/predictiveMaintenance/FetchInstallationsPredictedStatusCommand";
import { FetchInstallationsPredictedStatusResponse } from "@/model/communication/predictiveMaintenance/FetchInstallationsPredictedStatusResponse";
import { InstallationPredictedStatusEnum } from "@/model/data/predictiveMaintenance/InstallationPredictedStatusEnum";

export default Vue.extend({
    components: {
        StandardPage,
        InstallationsPredictedStatusSummary,
    },
    data() {
        return {
            routes,
            dataTableItemsPerPage,
            PMMainTable,
            reqData: null,
            installations: [],
            paginatedTotalItems: null,
            loading: false,
            loadingSummary: false,
            totalsByStatus: new Map<InstallationPredictedStatusEnum, number>(),
            filteredTotalsByStatus: new Map<InstallationPredictedStatusEnum, number>(),
        };
    },
    methods: {
        async sendRequest(request) {
            try {
                this.reqData = request;
                this.loading = true;
                this.loadingSummary = true;
                let response: FetchInstallationsPredictedStatusResponse = await new FetchInstallationsPredictedStatusCommand(request).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installations = response.installationsList;
                    this.paginatedTotalItems = response.totalInstallationsCount;
                    this.totalsByStatus = response.installationsCountByPredictedStatus;
                    this.filteredTotalsByStatus = response.filteredInstallationsCountByPredictedStatus;
                }
            } catch (e) {
                console.log("Something went wrong sending GetInstallationsEnabledModules request ", e);
            }
            this.loading = false;
            this.loadingSummary = false;
        },
        async sendRequestAndBackToTheFirstPage(request) {
            this.$refs.standardPage.backToTheFirst();
            this.sendRequest(request);
        },
    },
    mounted() {
        if (this.$route.query.reqData != null && this.$route.query.reqData != undefined) {
            this.reqData = JSON.parse(atob(this.$route.query.reqData));
        } else {
            this.reqData = new GetDevicesPredictedStatusReqData();
            this.reqData.queryLimit = this.dataTableItemsPerPage[0];
        }
    },
});
